<template>
	<div :class="{ 'form-group': true, 'has-error': error, 'has-warning': warning }">
		<label :for="id">{{ label }}</label>
		<slot></slot>
		<span v-show="error" class="help-block">{{ error }}</span>
		<span v-show="warning" class="help-block">{{ warning }}</span>
	</div>
</template>

<script>
export default {
	props: {
		label: {
			type: String,
			required: true,
		},
		error: {
			type: String,
			default: null,
		},
		warning: {
			type: String,
			default: null,
		},
		id: {
			type: String,
			default: null,
		},
	}
}
</script>
